"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Id_1 = require("@twii/core/lib/Id");
var ComponentIdSequence = new Id_1.Sequence("db-comp-");
exports.ComponentIdSequence = ComponentIdSequence;
